import Modal from '../../../../components/common/dialog/dialog.vue';
import store from '../../../../store';

import scrollIntoViewIfNeeded from '../../../../helpers/dom/scrollIntoViewIfNeeded';


export default {
   store,
   components: { Modal },
   data() {
      return {
         text: '',
         opts: {
            showHeader: false,
            showCancel: false
            // opts: {
            //    confirmText: '',
            //    showHeader: false,
            //    canConfirmChecker: this.canConfirmChecker
            // }


         }
      };
   },
   mounted() {
      const { dialogue } = this.$options;
      this.text = dialogue.split('\n').join('<br>');

      setTimeout(() => {
         const { dialogue } = this.$refs;
         if (!dialogue) {
            return;
         }

         const el = dialogue.querySelector('em');
         if (el) {
            scrollIntoViewIfNeeded(el, false, 0, true);
         }
      }, 25);
   }
};
